"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function developmentLog(logText) {
    if (process.env.NODE_ENV !== 'production') {
        console.log(`${logText}`);
    }
}
exports.default = developmentLog;
//# sourceMappingURL=index.js.map